import React, { createContext, useState } from "react";
import Cookies from "js-cookie";
import api from "../services/api";
import { toast } from "react-toastify";

export const AuthContext = createContext();

export function AuthProvider({ children }) {
  const cookiesUserToken = Cookies.get("user-token");
  const [token, settoken] = useState(!!cookiesUserToken ? JSON.parse(cookiesUserToken) : null);
  async function signIn({ email, password, type }) {
    try {
      const { data: _response } = await api.post(type === "formando" ? "sessions-graduating" : "sessions", {
        email,
        password,
      });
      const _token = {
        token: _response?.token,
        type: _response?.type,
      };
      Cookies.set("user-token", JSON.stringify(_token), { expires: 3650, sameSite: "strict" });
      settoken(_token);
      return true;
    } catch (__err) {
      if (__err.response?.data?.length > 0) {
        __err.response?.data?.forEach(_error => {
          toast.error(_error.message);
        });
      } else {
        const _message = __err.response?.data?.error?.message || "Falha ao tentar se conectar";
        toast.error(_message);
      }
      console.log("__err", __err);
      return false;
    }
  }
  function signOut() {
    Cookies.remove("user-token", { sameSite: "strict" });
    settoken(null);
    window.location.reload();
  }
  return (
    <AuthContext.Provider value={{ token: token?.token, tokenType: token?.type, signIn, signOut }}>
      {children}
    </AuthContext.Provider>
  );
}
